
        import * as module0 from '$components/breakpoints.min.js';import * as module1 from '$components/browser.min.js';import * as module2 from '$components/demo.js';import * as module3 from '$components/jquery.min.js';import * as module4 from '$components/jquery.scrollex.min.js';import * as module5 from '$components/jquery.scrolly.min.js';import * as module6 from '$components/main.js';import * as module7 from '$components/util.js'
        const modules = {
            "breakpoints.min.js": module0,
            "browser.min.js": module1,
            "demo.js": module2,
            "jquery.min.js": module3,
            "jquery.scrollex.min.js": module4,
            "jquery.scrolly.min.js": module5,
            "main.js": module6,
            "util.js": module7,
        };
        export default modules;
      